/**
 * Каналы Chatwoot → значок, цвет и русское название.
 * channel_type приходит как «Channel::Telegram»; наши: Channel::TelegramAccount (личный
 * аккаунт Телеграма, app/models/channel/telegram_account.rb) и Channel::Voice (голос, GiperVoice).
 */
import {
  Camera, Facebook, Globe, Mail, MessageCircle, MessageSquare, Phone, Plug, Send, Smartphone, UserRound,
  type LucideIcon,
} from 'lucide-react';

export interface ChannelKind {
  key: string;
  label: string;
  icon: LucideIcon;
  color: string;
}

const KINDS: Record<string, ChannelKind> = {
  Telegram: { key: 'telegram', label: 'Telegram', icon: Send, color: '#2AABEE' },
  TelegramAccount: { key: 'telegram-account', label: 'Telegram (аккаунт)', icon: UserRound, color: '#229ED9' },
  Whatsapp: { key: 'whatsapp', label: 'WhatsApp', icon: MessageCircle, color: '#25D366' },
  Instagram: { key: 'instagram', label: 'Instagram', icon: Camera, color: '#E1306C' },
  Facebook: { key: 'facebook', label: 'Facebook', icon: Facebook, color: '#1877F2' },
  FacebookPage: { key: 'facebook', label: 'Facebook', icon: Facebook, color: '#1877F2' },
  WebWidget: { key: 'web', label: 'Сайт', icon: Globe, color: '#14B8A6' },
  Api: { key: 'api', label: 'API', icon: Plug, color: '#A78BFA' },
  Email: { key: 'email', label: 'Почта', icon: Mail, color: '#F59E0B' },
  Voice: { key: 'voice', label: 'Звонки', icon: Phone, color: '#64748B' },
  Sms: { key: 'sms', label: 'СМС', icon: Smartphone, color: '#34D399' },
  TwilioSms: { key: 'sms', label: 'СМС', icon: Smartphone, color: '#34D399' },
  Line: { key: 'line', label: 'LINE', icon: MessageSquare, color: '#06C755' },
  Tiktok: { key: 'tiktok', label: 'TikTok', icon: MessageSquare, color: '#FE2C55' },
  TwitterProfile: { key: 'twitter', label: 'X', icon: MessageSquare, color: '#A1A1AA' },
};

const FALLBACK: ChannelKind = { key: 'other', label: 'Канал', icon: MessageCircle, color: 'var(--muted)' };

export function channelKind(channelType: string | undefined | null): ChannelKind {
  const t = (channelType ?? '').replace('Channel::', '');
  return KINDS[t] ?? FALLBACK;
}
